import { Chip, Autocomplete, TextField } from "@mui/material";

export default function RowTypeSelect(props) {
  return (
    <Autocomplete
      fullWidth
      multiple
      variant="outlined"
      id={props.id}
      name={props.id}
      options={[]}
      // defaultValue={props.choosen}
      value={props.choosen}
      freeSolo
      onChange={(e, newValue) => {
        props.onRowOptionsChange({ newValue, id: props.id });
      }}
      renderValue={(value, getItemProps) =>
        value.map((option, index) => {
          const { key, ...itemProps } = getItemProps({ index });
          return (
            <Chip variant="outlined" label={option} key={key} {...itemProps} />
          );
        })
      }
      renderInput={(params) => (
        <TextField
          {...params}
          // variant="filled"
          label="Select Options"
          placeholder="Type Option then tap enter"
        />
      )}
    />
  );
}
